import { Table, Space, Button, Popconfirm, Tooltip, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function EstadoFinancieroTable({ data, loading, onEdit, onDelete, permissionUpdate, permissionDelete }) {

  const renderTextWrap = (value, width = 250) => (
    <Text
      style={{
        display: "block",
        maxWidth: width,
        whiteSpace: "normal",
        wordBreak: "break-word"
      }}
    >
      {value}
    </Text>
  );

  const columns = [
    {
      title: "Estado",
      dataIndex: "estado",
      width: 300,
      render: (text) => renderTextWrap(text, 300)
    },
    {
      title: "Acciones",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Space>

          {permissionUpdate && (
            <Tooltip title="Editar">
              <Button
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record)}
              />
            </Tooltip>
          )}

          {permissionDelete && (
            <Popconfirm
              title="¿Eliminar estado?"
              okText="Eliminar"
              cancelText="Cancelar"
              onConfirm={() => onDelete(record)}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          )}

        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="oid"
      columns={columns}
      dataSource={data}
      loading={loading}
      bordered
      size="middle"
      pagination={{
        pageSize: 10,
        showSizeChanger: true
      }}
      style={{
        margin: "0 auto",
        borderRadius: 8,
        overflow: "hidden"
      }}
    />
  );
}